import { useEffect, useState, useCallback } from 'react'
// react-router-dom components

// @mui material components
import Card from '@mui/material/Card'

// Material Dashboard 2 React components
import MDBox from '../../../components/MDComponents/MDBox'
import MDTypography from '../../../components/MDComponents/MDTypography'
// Authentication layout components

import CoverLayout from '../../../layouts/authentication/components/CoverLayout'

import AuthService from '../../../services/auth-service.js'

// for the reset I should take from the url the token sent and the email
const ConfirmAccount = () => {
  const [token, setToken] = useState(null)
  const [email, setEmail] = useState(null)
  const [notification, setNotification] = useState(false)
  const [errors, setErrors] = useState({
    error: false,
    textError: '',
  })

  useEffect(() => {
    // get the token and email sent in the url
    const queryParams = new URLSearchParams(window.location.search)
    setToken(queryParams.get('token'))
    setEmail(queryParams.get('email'))
  }, [])

  const submitHandler = useCallback(async () => {
    const formData = {
      email,
      token,
    }

    const myData = {
      data: {
        type: 'confirm-account',
        attributes: { ...formData },
      },
    }

    try {
      setNotification(true)
      await AuthService.confirmAccount(myData)
      setErrors({
        error: false,
        textError: '',
      })
    } catch (err) {
      if (err.hasOwnProperty('errors')) {
        setErrors({
          ...errors,
          error: true,
          textError: err.errors.password[0],
        })
      }
      return null
    }
  }, [email, errors, token])

  useEffect(() => {
    submitHandler()
  }, [notification, submitHandler])

  return (
    <CoverLayout>
      <Card>
        <MDBox
          component="form"
          role="form"
          method="GET"
          onSubmit={submitHandler}
        >
          <MDBox
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="success"
            mx={2}
            mt={-3}
            p={3}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              You successfully confirmed your account!
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  )
}

export default ConfirmAccount
